import {
  getResource,
  LINE_ITEM_RESOURCE,
  SUB_LINE_ITEM_RESOURCE,
  PRODUCT_LINE_RESOURCE
} from "./actionLocator";

export class RoomBookController {
  constructor(dispatch, unitId) {
    this.dispatch = dispatch;
    this.unitId = unitId;
  }

  selectProductLine = tag => {
    return this.productLineResource().select(tag);
  };

  deselectProducts = subLineItemIds => {
    return this.subLineItemResource().deselectProducts(subLineItemIds);
  };

  selectProducts = selection => {
    return this.subLineItemResource().selectProducts(selection);
  };

  selectProductsAndQuantities = selection => {
    return this.subLineItemResource().selectProductsAndQuantities(selection);
  };

  toggleLineItem = (lineItemId, activate) => {
    return this.lineItemResource().toggle(lineItemId, activate);
  };

  deactivateLineItem = lineItemId => {
    return this.lineItemResource().deactivate(lineItemId);
  };

  activateLineItem = lineItemId => {
    return this.lineItemResource().activate(lineItemId);
  };

  /*
   * Resources
   */

  lineItemResource = () => {
    const Resource = getResource(LINE_ITEM_RESOURCE);
    return new Resource(this.dispatch, this.unitId);
  };

  subLineItemResource = () => {
    const Resource = getResource(SUB_LINE_ITEM_RESOURCE);
    return new Resource(this.dispatch, this.unitId);
  };

  productLineResource = () => {
    const Resource = getResource(PRODUCT_LINE_RESOURCE);
    return new Resource(this.dispatch, this.unitId);
  };
}

export const roomBookController = (dispatch, unitId) => {
  return new RoomBookController(dispatch, unitId);
};
